import { useEffect, useState } from 'react';
import usePublicPostApi from '~/public/lib/usePublicPostApi';
import * as ClientApi from '~/lib/ClientApi';
import TextInput from '~/components/TextInput';
import ClientLoginModal from '~/components/forms/questions/components/ClientLoginModal.jsx';

export const DEFAULT_LOGIN_DESCRIPTION =
    'Sign in to speed up the process, and save details to your account.';

const ClientLogin = ({ settings }) => {
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [isSkipped, setIsSkipped] = useState(false);

    if (isSkipped) {
        return (
            <div>
                <span className="text-gray-500">Continuing as a guest</span>
                <button
                    type="button"
                    className="form-button-light btn-small ml-6"
                    onClick={() => setIsSkipped(false)}
                >
                    Log in
                </button>
            </div>
        );
    }

    return (
        <div className="flex">
            <div className="flex-1 pr-6">
                <h3>Register or Log in</h3>
                <div className="text-gray-500 my-2 text-base">
                    {settings.loginDescription || DEFAULT_LOGIN_DESCRIPTION}
                </div>
                <button
                    type="button"
                    className="form-button btn-small"
                    onClick={() => setShowLoginModal(true)}
                >
                    Register/Log in
                </button>
                <ClientLoginModal
                    isOpen={showLoginModal}
                    onClose={() => setShowLoginModal(false)}
                />
            </div>
            {!settings?.required && (
                <div className="flex-1 pl-6">
                    <h3>Skip</h3>
                    <div className="text-gray-500 my-2 text-base">
                        {settings.skipDescription ||
                            'You will have an opportunity to create an account later.'}
                    </div>
                    <button
                        type="button"
                        className="form-button-light btn-small"
                        onClick={() => setIsSkipped(true)}
                    >
                        Skip
                    </button>
                </div>
            )}
        </div>
    );
};

export default ClientLogin;
